import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule, UpperCasePipe } from '@angular/common';
import { Component, Injector, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterModule, HeaderBrandComponent, HeaderComponent, HeaderTogglerDirective, SidebarModule, SidebarToggleDirective } from '@coreui/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DialogContainerDirective, WindowContainerDirective } from '@progress/kendo-angular-dialog';
import { AlertComponent } from 'ngx-bootstrap/alert';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppContainerDefaultClass } from '../../classes/appContainerDefault.class';
import { AppCustomBreadcrumbComponent } from '../../modules/@shared/components/breadcrumb/custom-breadcrumb.component';
import { AppLanguageSelectionComponent } from '../../modules/@shared/components/language-selection/language-selection.component';
import { AppNotifierBoxComponent } from '../../modules/@shared/components/notifier-box/notifier-box.component';
import { AppNotifierCounterComponent } from '../../modules/@shared/components/notifier-counter/notifier-counter.component';
import { AppGridAutoHeightDirective } from '../../modules/@shared/directives/gridAutoHeight.directive';
import { AppHasStatePermissionDirective } from '../../modules/@shared/directives/hasStatePermission.directive';
import { AppSafeHtmlPipe } from '../../modules/@shared/pipes/safeHtml.pipe';
import { AppAuthService } from '../../services/auth.service';
import { AppAuthDataService } from '../../services/authData.service';
import { AppDialogService } from '../../services/dialog.service';
import { AppEventService } from '../../services/event.service';

@Component({
  selector: 'app-root',
  templateUrl: './default-layout.html',
  styleUrl: './default-layout.scss',
  standalone: true,
  imports: [
    AlertComponent,
    AppCustomBreadcrumbComponent,
    AppHasStatePermissionDirective,
    AppGridAutoHeightDirective,
    AppLanguageSelectionComponent,
    AppNotifierBoxComponent,
    AppNotifierCounterComponent,
    AppSafeHtmlPipe,
    BsDropdownModule,
    CommonModule,
    DialogContainerDirective,
    FooterModule,
    HeaderBrandComponent,
    HeaderComponent,
    HeaderTogglerDirective,
    NgScrollbarModule,
    NgxSpinnerModule,
    RouterModule,
    SidebarModule,
    SidebarToggleDirective,
    TranslateModule,
    UpperCasePipe,
    WindowContainerDirective,
  ],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate('.25s ease-out', style({ opacity: '1' })),
      ]),
      transition(':leave', [
        style({ opacity: '1' }),
        animate('.25s ease-out', style({ opacity: '0' })),
      ]),
    ]),
  ]
})

/** Definizione del container di default */
export class DefaultLayoutComponent extends AppContainerDefaultClass {
  @ViewChild(AppCustomBreadcrumbComponent) breadcrumbComponent!: AppCustomBreadcrumbComponent;
  lastClick: any;
  constructor(
    public override appDialogService: AppDialogService,
    public override authDataService: AppAuthDataService,
    public override authService: AppAuthService,
    public override eventService: AppEventService,
    public override injector: Injector,
    public override translate: TranslateService) {
    super(appDialogService, authDataService, authService, eventService, injector, translate);
  }
  override onItemClick(event: any) {
    this.breadcrumbComponent.ngOnInit();
  }
}
